import React, { FC } from 'react';
import cx from 'classnames';

// components
import { Checkbox, TextInput } from 'src/components/Inputs';
import Image from 'src/components/Image';
import Tooltip from 'plaid-threads/Tooltip'; // eslint-disable-line no-restricted-imports
import styles from './FormSectionSolutionsFields.module.scss';
import { FormSectionSolutionsFieldsProps } from './FormSectionSolutionsFields.types';

const FormSectionSolutionsFields: FC<FormSectionSolutionsFieldsProps> = ({
  formData,
  setValue,
  errors,
  register,
  clearErrors,
  getValues,
}) => {
  // This form field isn't defined in Marketo and should be automatically
  // dropped. It's used as a workaround for custom internal validation.
  const solutionsValidatorField = '_internal_solutions_validator';

  return (
    <fieldset className='solutions-field'>
      <p>{formData.solutions.label}</p>
      {formData.solutions.options.map((option) => {
        return (
          <div
            className={cx(
              'checkbox-tooltip-container',
              styles.checkboxContainer,
            )}
          >
            <Checkbox
              key={option.id}
              id={option.id}
              name={option.id}
              onChange={(e) => {
                setValue(option.id, e.target.checked);
                clearErrors(solutionsValidatorField);

                setValue(
                  solutionsValidatorField,
                  getValues(
                    formData.solutions.options.map(({ id }) => {
                      return id;
                    }),
                  ).some(Boolean)
                    ? 'at-least-one-solution-selected'
                    : '',
                );
              }}
              hasError={!!errors?.[solutionsValidatorField]?.message}
            >
              {option.label}
            </Checkbox>
            <Tooltip
              placement='top'
              showOn='hover'
              small
              target={
                <Image
                  className='info-dropdown inject-me'
                  src='/assets/img/icons/info-icon.svg'
                  aria-describedby='learn more'
                  alt='information icon'
                />
              }
            >
              {option.tooltipDescription}
            </Tooltip>
          </div>
        );
      })}
      <div
        style={{
          height: errors?.[solutionsValidatorField]?.message ? 'auto' : 0,
        }}
      >
        <TextInput
          type='hidden'
          label=''
          name={solutionsValidatorField}
          id={solutionsValidatorField}
          errorMessage={errors?.[solutionsValidatorField]?.message}
          register={register}
          required='Please select at least one solution you are interested in.'
          value={getValues(solutionsValidatorField)}
        />
      </div>
    </fieldset>
  );
};

export default FormSectionSolutionsFields;
